import login from './login';

export default {

    /** 用户登录 */
    login,
};


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/api/webToken/index.ts